/* 給トク支払区分 */
export default {
    // 限定なし
    NO_LIMIT: "0",
    // 給トクのみ
    ONLY_KYUTOKU: "1",
    // 給トク以外
    EXCEPT_KYUTOKU: "2"
}